import React, { useState, useEffect } from "react";
import { phoneNumber, email } from "../components/Constants";
import { Link, useLocation } from "react-router-dom";

const CustomerReceipt = () => {
  const location = useLocation();
  const [apiData, setApiData] = useState(location.state?.result || null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.state?.result) {
      setApiData(location.state.result);
    }
  }, [location.state]);

  const handlePrint = () => {
    window.print();
  };

  function formatDate(dateTimeString) {
    if (!dateTimeString) return "";
    try {
      const options = {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateTimeString).toLocaleString("en-US", options);
    } catch (_) {
      return dateTimeString;
    }
  }

  const capitalizeFirstLetter = (word) => {
    if (!word) return "";
    return String(word).charAt(0).toUpperCase() + String(word).slice(1).toLowerCase();
  };

  // Direct access ya empty state par crash se bachane ke liye fallback UI
  if (!apiData) {
    return (
      <div className="container text-center py-5 my-5">
        <div className="card shadow-sm p-4 mx-auto" style={{ maxWidth: "500px" }}>
          <h4 className="font-weight-bold mb-2">No Active Booking Session Found</h4>
          <p className="text-muted small">
            If you refreshed the page or entered the link directly, your booking reference is stored in the system.
          </p>
          <Link to="/" className="btn btn-danger mt-3">
            Go to Home
          </Link>
        </div>
      </div>
    );
  }

  const userInformation = apiData?.userInformation || {};
  const keys = Object.keys(userInformation);
  const flightData = apiData?.flightData?.data?.[0];
  const itineraries = flightData?.itineraries || [];
  const carriersDict = apiData?.flightData?.dictionaries?.carriers || {};
  const fareDetails = apiData?.fareDetails || {};

  const totalAmountVal = parseFloat(fareDetails.totalAmount || 0);
  const baseAmount = fareDetails.travelerDetails?.[0]?.totalAmount || (totalAmountVal * 0.72).toFixed(2);
  const taxAmount = fareDetails.travelerDetails?.[0]?.taxAmount || (totalAmountVal * 0.28).toFixed(2);
  const cabinAmountDisplay = fareDetails.cabinAmount
    ? `USD ${fareDetails.cabinAmount}`
    : fareDetails.protection
    ? "USD 89.00"
    : "No";

  return (
    <div style={{ background: "#fff", border: "1px solid #000" }} className="container-fluid py-3">
      <div className="tem-section">
        {/* Header with Reference & Print */}
        <div style={{ backgroundColor: "#fff", padding: 10, textAlign: "left" }}>
          <table width="100%" cellPadding={0} cellSpacing={0}>
            <tbody>
              <tr>
                <td style={{ textAlign: "left", width: "40%" }}>
                  <Link to="/">
                    <img src="images/logo.png" alt="Logo" style={{ width: 130 }} />
                  </Link>
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    width: "60%",
                    fontSize: 16,
                  }}
                >
                  <b>Booking Reference # {apiData?.randomNumber}</b>{" "}
                  <button className="btn btn-sm btn-outline-dark mx-2" onClick={handlePrint}>
                    Print Receipt
                  </button>
                  <Link to="/" className="btn btn-sm btn-danger">
                    Go To Home
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Support Bar */}
        <div className="need mb-3" style={{ background: "#343f55", textAlign: "right" }}>
          <p
            style={{
              color: "#fff",
              fontSize: 15,
              padding: "4px 0.8rem",
              margin: 0,
            }}
          >
            Need help? 24x7 Toll Free Support:{" "}
            <b style={{ color: "#fff" }}>{phoneNumber}</b>
          </p>
        </div>

        {/* Status Notice */}
        <div className="book-para px-2">
          <p>
            Your Booking is <b>confirmed & in progress</b> with reference number:{" "}
            <b className="text-primary">{apiData?.randomNumber}</b>
          </p>
          <p className="small text-muted">
            If you have any queries, please contact our support team at{" "}
            <strong>{phoneNumber}</strong> or via email at <strong>{email}</strong>.
          </p>
        </div>

        {/* 1. Travellers Details */}
        <div className="col-12 mt-4">
          <div style={{ background: "#343f55", textAlign: "left" }}>
            <p style={{ color: "#fff", fontSize: 16, padding: "6px 0.8rem", margin: 0 }}>
              Traveller(s) Details
            </p>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table width="100%" style={{ borderCollapse: "collapse", border: "1px solid #000" }}>
              <thead>
                <tr style={{ backgroundColor: "#cccccc8a", textAlign: "left" }}>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>S.No.</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Type</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>First Name</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Middle Name</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Last Name</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Gender</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>DOB</th>
                </tr>
              </thead>
              <tbody>
                {keys.length === 0 ? (
                  <tr style={{ background: "#fff" }}>
                    <td colSpan={7} style={{ padding: "8px", textAlign: "center" }}>
                      Primary Passenger
                    </td>
                  </tr>
                ) : (
                  keys.map((key, index) => {
                    const passenger = userInformation[key] || {};
                    return (
                      <tr key={key} style={{ background: "#fff" }}>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {index + 1}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {key.toUpperCase().includes("CHILD")
                            ? "Child"
                            : key.toUpperCase().includes("INFANT")
                            ? "Infant"
                            : "Adult"}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {capitalizeFirstLetter(passenger.firstName || "Traveler")}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {capitalizeFirstLetter(passenger.middleName || "-")}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {capitalizeFirstLetter(passenger.lastName || "")}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {passenger.gender || "Male"}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {passenger.dob || passenger.date || "-"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* 2. Flight Details */}
        <div className="col-12 mt-4">
          <div style={{ background: "#343f55", textAlign: "left" }}>
            <p style={{ color: "#fff", fontSize: 16, padding: "6px 0.8rem", margin: 0 }}>
              Flight Itinerary Details
            </p>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table width="100%" style={{ borderCollapse: "collapse", border: "1px solid #000" }}>
              <thead>
                <tr style={{ backgroundColor: "#cccccc8a", textAlign: "left" }}>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Airline</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Departure</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Arrival</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Flight No.</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Cabin</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Duration</th>
                </tr>
              </thead>
              <tbody>
                {itineraries.flatMap((itinerary) =>
                  (itinerary.segments || []).map((segment, segmentIndex) => {
                    const carrierCode = segment?.carrierCode;
                    const fullCarrierName = carriersDict[carrierCode] || carrierCode;
                    const cabinType =
                      flightData?.travelerPricings?.[0]?.fareDetailsBySegment?.[0]?.cabin || "Economy";

                    return (
                      <tr key={segmentIndex} style={{ background: "#fff" }}>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          <strong>{fullCarrierName}</strong>
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          <b>{segment?.departure?.iataCode}</b>
                          <br />
                          {formatDate(segment?.departure?.at)}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          <b>{segment?.arrival?.iataCode}</b>
                          <br />
                          {formatDate(segment?.arrival?.at)}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {segment?.carrierCode}&nbsp;{segment?.number}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {capitalizeFirstLetter(cabinType)}
                        </td>
                        <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                          {itinerary.duration ? itinerary.duration.replace("PT", "").toLowerCase() : "2h 15m"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* 3. Customer Contact Details */}
        <div className="col-12 mt-4">
          <div style={{ background: "#343f55", textAlign: "left" }}>
            <p style={{ color: "#fff", fontSize: 16, padding: "6px 0.8rem", margin: 0 }}>
              Customer Contact Details
            </p>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table width="100%" style={{ borderCollapse: "collapse", border: "1px solid #000" }}>
              <thead style={{ backgroundColor: "#cccccc8a" }}>
                <tr style={{ textAlign: "left" }}>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Email Id</th>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Contact Number</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ textAlign: "left", background: "#fff" }}>
                  <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                    {apiData?.emaiAndId?.email || "customer@example.com"}
                  </td>
                  <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>
                    {apiData?.emaiAndId?.phone || phoneNumber}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* 4. Price Breakdown */}
        <div className="col-12 mt-4 mb-4">
          <div style={{ background: "#343f55", textAlign: "left" }}>
            <p style={{ color: "#fff", fontSize: 16, padding: "6px 0.8rem", margin: 0 }}>
              Payment & Price Breakdown
            </p>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table width="100%" style={{ borderCollapse: "collapse", border: "1px solid #000" }}>
              <tbody style={{ textAlign: "left", background: "#fff" }}>
                <tr>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Base Amount</th>
                  <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000", textAlign: "right" }}>
                    USD {baseAmount}
                  </td>
                </tr>
                <tr>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Cabin / Trip Protection</th>
                  <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000", textAlign: "right" }}>
                    {cabinAmountDisplay}
                  </td>
                </tr>
                <tr>
                  <th style={{ padding: "8px", fontSize: "14px", border: "1px solid #000" }}>Taxes and Carrier Fees</th>
                  <td style={{ padding: "8px", fontSize: "14px", border: "1px solid #000", textAlign: "right" }}>
                    USD {taxAmount}
                  </td>
                </tr>
                <tr style={{ background: "#f8f9fa" }}>
                  <th style={{ padding: "8px", fontSize: "16px", border: "1px solid #000" }}>Total Amount Paid</th>
                  <td
                    style={{
                      padding: "8px",
                      fontSize: "16px",
                      border: "1px solid #000",
                      textAlign: "right",
                      fontWeight: "bold",
                      color: "#198754",
                    }}
                  >
                    USD {fareDetails.totalAmount || totalAmountVal.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerReceipt;
                  
